function isFieldFocused() {
  const focusedField = document.activeElement
  return focusedField && focusedField.matches(up.form.fieldSelector())
}

function modifiedKey(key, event) {
  if (event.shiftKey) { key = 'Shift+' + key }
  if (event.altKey) { key = 'Alt+' + key }
  if (event.metaKey) { key = 'Meta+' + key }
  if (event.ctrlKey) { key = 'Ctrl+' + key }
  return key
}

up.compiler('[hotkey]', function(element) {
  // Modifier keys are allowed. They have to be in the order
  // Ctrl+Meta+Alt+Shift+key
  const hotkeys = element.getAttribute('hotkey').split(' ')
  const allowFocusedField = element.getAttribute('hotkey-allow-focused-field')

  const unbind = up.layer.on('keydown', 'body', function(event) {
    if (!allowFocusedField && isFieldFocused()) {
      // Ignore hotkeys when a field is focused
      return
    }

    let eventKey = event.key
    if (eventKey === 'Esc') { // IE specific value
      eventKey = 'Escape'
    }

    eventKey = modifiedKey(eventKey, event)

    if (up.util.contains(hotkeys, eventKey)) {
      if (['BUTTON', 'INPUT'].includes(element.nodeName)) { element.click() } else { up.follow(element) }
      up.event.halt(event)
    }
  })

  return unbind
})
